import Reveal from "@/components/Reveal";
import SectionOrnament from "@/components/SectionOrnament";

// Compact page hero band used on inner pages.
export function PageHero({ overline, title, subtitle }) {
  return (
    <section className="relative bg-secondary pt-36 pb-20 px-6 text-center border-b border-border overflow-hidden">
      <SectionOrnament variant="corners" />
      <div className="relative">
        <Reveal>
          {overline && <p className="text-xs tracking-[0.35em] uppercase text-gold mb-5">{overline}</p>}
          <h1 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl leading-tight text-ink">{title}</h1>
          <div className="mt-6"><SectionOrnament variant="divider" /></div>
          {subtitle && <p className="mt-6 max-w-2xl mx-auto text-ink-muted font-light">{subtitle}</p>}
        </Reveal>
      </div>
    </section>
  );
}

export default PageHero;
